import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IGetStudents, IStudent } from '../../../../models/pushMessage.model';
import { Button as AntButton, Modal } from 'antd';
import FileUpload from '../../../FileUpload';
import Button from '../../../Button';
// @ts-ignore
import { ExcelRenderer } from 'react-excel-renderer';
import useAxios from '../../../../hooks/useAxios';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { getStudents } from '../../../../api/pushMessage.api';
import Loader from '../../../Loader';
import ErrorResponse from '../../../ErrorResponse';
import _ from 'lodash';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  students: IStudent[];
  setStudents: (students: IStudent[]) => void;
}

const UploadExcelModal: FC<IProps> = ({
  visible,
  setVisible,
  students,
  setStudents,
}) => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const [file, setFile] = useState<any>(null);
  const { data: res, isLoading, error, execute } = useAxios<IGetStudents>();
  const [data, setData] = useState<IStudent[] | undefined>();
  const [memCode, setMemcode] = useState<any>([]);
  const [excelD, setExcelD] = useState<any>([]);

  useEffect(() => {
    if (res && !isLoading) {
      setData(res.data);
    }
  }, [res, isLoading]);

  const onHandleExcel = (fileObj: any) => {
    setData([]);
    setFile(fileObj);
    ExcelRenderer(fileObj, (error: any, response: any) => {
      if (error) {
        return;
      }
      
      const excelObj = { cols: response.cols, rows: response.rows };
      const memberCodes: string[] = [];
      const excelData: any = [];
      //excelObj.rows.forEach((row: any) => memberCodes.push(row[0]));
      excelObj.rows.forEach((row: any) => excelData.push({
        memberCode: row[0],
        sub1: row[1],
        sub2: row[2]
      }));
      // memberCodes.shift();
      excelData.shift();
      setMemcode(excelData);
      setExcelD(excelData)
      execute(
        getStudents({
          campusCode: currentCampus,
          memberCode: excelData.map((item: any)=> item.memberCode),
        }),
      );
      
    });
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('sms.send.title2')}
        visible={visible}
        onCancel={() => {
          setData([]);
          setVisible(false);
        }}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => {
                if (data) {
                  const _students = [...students, ...data];
                  const result = _.uniqBy(_students, 'memberCode').map((item)=> {
                    return {
                      ...item,
                      ...excelD.find((excelItem: any)=> excelItem.memberCode === item.memberCode)
                    }
                  })
                  setStudents(result);
                }
                setData([]);
                setVisible(false);
              }}
              disabled={!data || data?.length === 0}
            >
              {t('student.student.button4')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => {
                setData([]);
                setVisible(false);
              }}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex flex-justify-center">
          <FileUpload file={file} setFile={onHandleExcel} accept=".xlsx" />
          <div
            style={{
              position: 'relative',
              top: '1px',
            }}
          >
            <a
              className="download-link"
              href="/upload_students.xlsx"
              download="upload_students.xlsx"
            >
              <div className='comm-btn__area ml-2'>
                <Button
                  className="btn-basic green"
                  onClick={() => {}}
                  text={t('sms.send.button5')}
                  useExcelIcon
                />
              </div>
            </a>
          </div>
        </div>
        {data ? (
          <div className="mt-3 text-center">
            {t('sms.send.text4')} {memCode.length}
            {t('sms.send.text5')}
          </div>
        ) : null}
      </Modal>
    </>
  );
};

export default UploadExcelModal;
